/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverSettlementDetailsTrips: "driver-settlement-details-trips",
} as const;
